import { IcMarkerCfs } from '@/assets/images';
import { DroppableCFS } from '@/components/DragAndDrop/DroppableCFS';

interface DroppableIcMarkerCfsProps {
  color: string;
  isDroppable?: boolean;
  cfsId?: string;
  cfsNumber?: string;
  address?: string;
}
export const DroppableIcMarkerCfs = ({
  color,
  isDroppable,
  cfsId,
  cfsNumber,
  address,
}: DroppableIcMarkerCfsProps) => {
  const markerSvg = (
    <IcMarkerCfs color={color} style={{ width: 50, height: 50 }} />
  );

  if (isDroppable && cfsId && cfsNumber && address) {
    return (
      <DroppableCFS cfsId={cfsId} cfsNumber={cfsNumber} address={address}>
        {markerSvg}
      </DroppableCFS>
    );
  }

  return markerSvg;
};
